import {
  FETCH_ROLE_MENU_PERMISSIONS_REQUEST,
  FETCH_ROLE_MENU_PERMISSIONS_SUCCESS,
  FETCH_ROLE_MENU_PERMISSIONS_FAILURE
} from '../types/roleMenuPermissionsTypes';

const initialState = {
  loading: false,
  allowedMenuKeys: [],
  error: null
};

const roleMenuPermissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLE_MENU_PERMISSIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ROLE_MENU_PERMISSIONS_SUCCESS:
      return { ...state, loading: false, allowedMenuKeys: action.payload, error: null };
    case FETCH_ROLE_MENU_PERMISSIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default roleMenuPermissionsReducer; 